type Distributed<A> = A extends unknown ? A : never;

export const undistributed = <A>(a: Distributed<A>): A => a;
